import { render, staticRenderFns } from "./GraficaFondos.vue?vue&type=template&id=53898c0e&"
import script from "./GraficaFondos.vue?vue&type=script&lang=js&"
export * from "./GraficaFondos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports